import React from "react";
const SvgLoginPublishAd = props => (
  <svg fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M8.5 5.75A3.25 3.25 0 005.25 9v15a3.25 3.25 0 003.25 3.25h15A3.25 3.25 0 0026.75 24v-8.023a.75.75 0 011.5 0V24a4.75 4.75 0 01-4.75 4.75h-15A4.75 4.75 0 013.75 24V9A4.75 4.75 0 018.5 4.25h8.546a.75.75 0 010 1.5H8.5z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M9.25 19a.75.75 0 01.75-.75h12a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zm0 4.5a.75.75 0 01.75-.75h12a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zm.27-13.722a.75.75 0 01.75.75v3.577a.41.41 0 00.412.411h3.871a.41.41 0 00.412-.411V10.59a.75.75 0 111.5 0v3.515a1.91 1.91 0 01-1.912 1.911h-3.87a1.91 1.91 0 01-1.912-1.911v-3.577a.75.75 0 01.75-.75z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M11.629 7.878a1.53 1.53 0 011.893 0l.005.004 3.391 2.71a.75.75 0 11-.936 1.172l-3.387-2.706a.032.032 0 00-.02-.008.032.032 0 00-.02.008l-3.387 2.706a.75.75 0 11-.936-1.172l3.397-2.714zM23.431 9.56a.75.75 0 010 1.06l-3.033 3.03a.75.75 0 01-1.06-1.06l3.033-3.03a.75.75 0 011.06 0z"
      clipRule="evenodd"
    />
    <path
      fill="#E4002B"
      d="M24.052 5.513l1.954-1.952a.967.967 0 00.287-.787l-.14-1.238a.486.486 0 01.427-.533.465.465 0 01.394.14l4.884 4.878a.48.48 0 010 .681.473.473 0 01-.394.14l-1.24-.14a.944.944 0 00-.787.287l-1.954 1.952a.97.97 0 00-.287.68v3.411a.97.97 0 01-1.65.69l-6.263-6.257a.963.963 0 01.681-1.648h3.415a.96.96 0 00.681-.28l-.008-.024z"
    />
  </svg>
);
export default SvgLoginPublishAd;
